import type { MenuDto, OfferDto } from "@deliveryapp/shared";

const COMPLEMENT = /(desert|prajitur|dulciur|baut|suc|apa|cafe|ceai|sos|garnitur|cartof)/i;
const MAIN = /(mic dejun|combinat|fara carne|pește|peste|salat|porc|vită|vita|burger|pizza|sandwich|starter|paste|pui|grătar|gratar|fel principal)/i;
const ALCOHOL = /(alcool|aperol|bere|beer|vin|wine|vodka|whisk|rom\b|rum\b|gin\b|cocktail|prosecco|spirit|lichior|coniac|cognac|tequila)/i;
const FEATURED = /(recomand|popular|featured|best.?seller)/i;

function searchable(offer: OfferDto): string {
  return `${offer.categoryPath} ${offer.name} ${offer.dietTags.join(" ")}`;
}

/**
 * O selectie scurta si explicabila, nu o pretentie de „popularitate" fara
 * date. Ordinea configurata in meniu ramane baza; etichetele editoriale au
 * prioritate, iar dupa ce exista produse in cos urca garniturile, sosurile,
 * bauturile si deserturile. Alcoolul nu ocupa primul ecran din oficiu.
 */
export function recommendedOffers(
  menus: MenuDto[],
  cartOfferIds: ReadonlySet<string>,
  limit = 6,
): OfferDto[] {
  const hasCart = cartOfferIds.size > 0;
  const candidates = menus
    .flatMap((menu) => menu.offers)
    .filter((offer) => offer.available && !cartOfferIds.has(offer.offerId))
    .map((offer, index) => {
      const text = searchable(offer);
      const score =
        (FEATURED.test(text) ? 1000 : 0) +
        (hasCart && COMPLEMENT.test(text) ? 300 : 0) +
        (!hasCart && MAIN.test(text) ? 300 : 0) +
        (Array.isArray(offer.images) && offer.images.length > 0 ? 50 : 0) +
        (ALCOHOL.test(text) ? -1000 : 0) -
        index;
      return { offer, score };
    })
    .sort((a, b) => b.score - a.score);

  const selected: OfferDto[] = [];
  const categories = new Set<string>();
  for (const { offer } of candidates) {
    const category = offer.categoryPath.toLocaleLowerCase("ro-RO");
    if (categories.has(category) && candidates.length > limit) continue;
    categories.add(category);
    selected.push(offer);
    if (selected.length >= limit) break;
  }

  // Un meniu cu o singura categorie nu trebuie sa ramana cu un singur card.
  if (selected.length < Math.min(limit, candidates.length)) {
    for (const { offer } of candidates) {
      if (selected.some((entry) => entry.offerId === offer.offerId)) continue;
      selected.push(offer);
      if (selected.length >= limit) break;
    }
  }
  return selected;
}
